<template>
  <div id="offerDetails">
    <div  class="social-nav filter-blur-50 border-bottom-white-1-50" >
      <div class="nameContainer" style="width: 100vw">
        <router-link to="/personal" class="d-flex">
          <div class="homeIcon">
            <a><img src="../../assets/icons/homeIcon.svg" height="20px" width="20px"></a>
          </div>
        </router-link>
        <div class="arrowIcon">
          <img src="../../assets/icons/rightArrow.svg" height="15px" width="15px">
        </div>
        <router-link to="/offers" class="d-flex">
          <div class="bundleTitle">
            {{offersTitle}}
          </div>
        </router-link>
        <div class="arrowIcon">
          <img src="../../assets/icons/rightArrow.svg" height="15px" width="15px">
        </div>
        <div class="titleName">{{mtnAppName}}</div>
      </div>
<!--      <div :class="[this.$lang === 'ar' ? 'flex-start-center' : '', 'checkContainer']" >-->
<!--        <form :class="[this.$lang === 'ar' ? 'flex-row-reverse' : '', 'filterForm']">-->
<!--          <div class="checkName">{{$t('popularBundles.showResults')}}</div>-->
<!--          <div class="check">-->
<!--            <input type="radio" id="pre" name="filter" value="0" checked @change="filter(0)" >-->
<!--            <label for="pre" class="radioLabel pre">{{$t('popularBundles.PrePaid')}}</label>-->
<!--          </div>-->
<!--          <div class="check">-->
<!--            <input type="radio" id="post" name="filter" value="1" @change="filter(1)" >-->
<!--            <label for="post" class="radioLabel post">{{$t('popularBundles.PostPaid')}}</label>-->
<!--          </div>-->
<!--        </form>-->
<!--      </div>-->
    </div>
    <div v-if="show && !error" style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center; min-height: calc(100vh - ( 280px + 170px));">
      <Loader />
    </div>
    <Error v-if="error" style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center; min-height: calc(100vh - ( 280px + 170px));"/>
    <div class="mtnRadioContainer" v-if="!show && !error" :class="[this.$lang === 'ar' ? 'right-dir' : '','']">
      <div class="Radiobackground" :class="[this.$lang === 'ar' ? 'leftPosition' : 'rightPosition','']">
        <div class="mainContainer">
<!--          <div class="mtnBack">-->
<!--            <router-link to="/">-->
<!--              <a>-->
<!--              <img src="../../assets/icons/backArrow.svg" style="cursor: pointer">-->
<!--              </a>-->
<!--            </router-link>-->
<!--          </div>-->
          <div class="mtnRadioText"  :class="[this.$lang === 'ar' ? 'rightPadding' : '','']">
            <div class="MTMRadioTitle d-flex">
              <div class="mainTitle" :class="[this.$lang === 'ar' ? 'arabic-bold text-right' : '','']">{{mtnAppName}}</div>
            </div>
            <div class="mtnRadioImageSmall ">
              <img :src="background" class="d-img-sm w-100 radius-28 max-h">
            </div>
            <div class="priceContainer" v-if=" lang === 'en'"><span class="Price">{{price}}</span><span v-if="this.$store.state.selectedNumber !== null && $route.params.type === 'special'">/</span><span style="font-size: 7px">&nbsp;</span><span v-if="this.$store.state.selectedNumber !== null && $route.params.type === 'special'" class="unit" :class="lang === 'ar' ? 'pr-1' : ''">{{unit}}</span>
              <label class="switch" v-if="this.$store.state.selectedNumber !== null && $route.params.type === 'special'">
                <input @click="activate" v-model="active" type="checkbox">
                <span class="slider" :class="active ? '' : 'inactive'"></span>
                <div :style="{transform : active ? 'translateX(1.2em)' : 'translateX(0em)'}" class="slider-border"></div>
              </label>
            </div>
            <div class="priceContainer right-align" v-if="lang === 'ar'"><span class="Price">{{price}}&nbsp;</span><span v-if="this.$store.state.selectedNumber !== null && $route.params.type === 'special'">/</span><span style="font-size: 7px">&nbsp;</span><span v-if="this.$store.state.selectedNumber !== null && $route.params.type === 'special'" class="unit" :class="lang === 'ar' ? 'pr-1' : ''">{{unit}}</span>
              <label class="switch" v-if="this.$store.state.selectedNumber !== null && $route.params.type === 'special'">
                <input @click="activate" v-model="active" type="checkbox">
                <span class="slider" :class="active ? '' : 'inactive'"></span>
                <div :style="{transform : active ? 'translateX(1.2em)' : 'translateX(0em)'}" class="slider-border"></div>
              </label>
            </div>
            <div class="radioDescription click-address" :class="lang === 'ar' ? 'right-align'  : ''" v-html="description">
<!--           {{description}}-->
            </div>
<!--            <div class="main-title font-18 mb-3" :class="lang === 'ar' ? 'arabicDir'  : ''">{{$t('digitalServices.download')}}</div>-->
<!--            <div  :class="lang === 'ar' ? 'rightButtons'  : ''">-->
<!--              <div :class="[$store.state.window < 380 && this.$lang === 'ar' ? 'right-dir' : '','buttons']">-->
<!--                <v-btn :class="[$store.state.window < 380 ? '' : 'mr-4' ,'flex-center download-btn']"  target="_blank" :href="appstore">-->
<!--                  <img class="icon" src="../../assets/icons/apple.svg">-->
<!--                  <div>-->
<!--                    <div class="download">{{$t('mtnApp.download')}}</div>-->
<!--                    <div class="site">App Store</div>-->
<!--                  </div>-->
<!--                </v-btn>-->
<!--                <v-btn class="flex-center download-btn"  target="_blank" :href="googleplay">-->
<!--                  <img class="icon" src="../../assets/icons/google.svg">-->
<!--                  <div>-->
<!--                    <div class="download">{{$t('mtnApp.git')}}</div>-->
<!--                    <div class="site">Google Play</div>-->
<!--                  </div>-->
<!--                </v-btn>-->
<!--              </div>-->
<!--            </div>-->
          </div>
          <div class="mtnRadioImage" :class="this.$lang === 'ar' ? 'padding-ar' : 'padding-en'">
            <img :src="background" class="radioImage">
          </div>
        </div>
<!--        <div class="yellowButton">-->
<!--          <additional-info-card/>-->
<!--        </div>-->
        <div v-if="offerType === 'special'">
          <div v-for="(item, i) in miniCards" :key="i" class="d-inline-block" style="margin-top: 20px">
            <div class="bundle d-inline-block" v-if="item.description !== '' && item.description !== null">
              <div class="bundle-basic gray-gradient-bottom0 bundle-shadow flex-center">
                <div class="">
                  <div class="card-icon">
                    <img :src="require(`../../assets/icons/${item.icon}`)">
                  </div>
                  <div class="card-title" :class="lang === 'ar' ? 'descriptionDir' : ''">
                    {{item.title}}
                  </div>
                  <div class="card-description">
                    {{item.description}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <InsureActivation @close="close" :id="Number(id)" method="post" type="offers" v-if="ensure" :active="isActive" />
  </div>
</template>

<script>
import $ from 'jquery'
import gc from '../../utils/gc'
import Loader from '../../components/LoaderBtn/Loader'
import Error from '../../components/errorHandle/Error'
import OfferDetailsRepository from '../../repositories/OfferDetailsRepository'
import SpecialOffersRepository from '../../repositories/SpecialOffersRepository'
import InsureActivation from '../../components/dialogs/InsureActivation'
export default {
  name: 'OfferDetails',
  components: { Loader, Error, InsureActivation },
  data () {
    return {
      ensure: false,
      active: false,
      lang: this.$lang,
      offers: new OfferDetailsRepository(),
      specialOffers: new SpecialOffersRepository(),
      offersTitle: '',
      mtnAppName: '',
      description: '',
      filterType: 0,
      appIcon: '',
      background: '',
      id: '',
      base: gc.baseUrl,
      appstore: '',
      googleplay: '',
      price: '',
      isActive: false,
      show: true,
      error: false,
      offerType: 'special',
      unit: '',
      miniCards: [{ title: '', description: '', icon: 'internet.svg' },
        { title: '', description: '', icon: 'calls.svg' },
        { title: '', description: '', icon: 'SMS.svg' },
        { title: '', description: '', icon: 'code.svg' },
        { title: '', description: '', icon: 'validation.svg' }]
    }
  },
  mounted () {
    this.offerType = this.$route.params.type
    this.offersTitle = this.offerType !== 'special' ? this.$t('offers.title') : this.$t('offers.special')
    this.getData(this.offerType !== 'special' ? this.offers : this.specialOffers)
    this.arabic()
    this.arabicRadio()
  },
  created () {
    this.id = this.$route.params.id
    this.$store.state.activeSectionNav = 3
    // At change the main account, we should go to offers page to reload offers with selected gsm
    this.$watch(() => {
      return this.$store.state.selectedNumber
    }, (val) => {
      this.goToOffers()
    })
  },
  methods: {
    activate () {
      this.ensure = true
      // this.active = this.info.main.isActive
    },
    close () {
      this.ensure = false
      this.active = this.isActive
    },
    goToOffers () {
      this.$router.push('/offers')
    },
    arabic () {
      if (this.$lang === 'ar') {
        $('.social-nav, .priceContainer').css('direction', 'rtl')
        $('.mainContainer').css('direction', 'rtl')
        $('.mtnRadioText').css('text-align', 'right')
        $('.checkName, .titleName, .MTMRadioTitle, .main-title, .Price, .month').css('font-family', 'Mtn-arabic-bold')
        $('.arrowIcon, .mtnBack').css('transform', 'rotateY(180deg)')
        $('.tabsContainer').addClass('arabicTabContainer')
        $('.nav-tab .v-tab').css('transform', 'rotateY(180deg)')
        $('.checkContainer, .buttons').css('direction', 'ltr')
        $('.radioLabel').css('font-family', 'Mtn-regular')
        $('.bundleTitle').css('font-family', 'Mtn-arabic-regular')
        $('.Radiobackground').css('background-position-x', 'left')
      }
    },
    arabicRadio () {
      if (this.$lang === 'ar') {
        $('.post').css('font-family', 'Mtn-arabic-regular')
        $('.pre').css('font-family', 'Mtn-arabic-regular')
        $('.post').css('font-size', '10px')
        $('.pre').css('font-size', '10px')
        if ($('#pre').is(':checked')) {
          $('.pre').css('font-family', 'Mtn-arabic-bold')
          $('.pre').css('font-size', '10px')
          // $('.post').css('font-family', 'Mtn-arabic-regular')
          // $('.post').css('font-size', '11px')
        } else if ($('#post').is(':checked')) {
          $('.post').css('font-family', 'Mtn-arabic-bold')
          $('.post').css('font-size', '10px')
          // $('.pre').css('font-family', 'Mtn-arabic-regular')
          // $('.pre').css('font-size', '11px')
        }
      }
    },
    async getData (repo) {
      this.show = true
      try {
        const response = await repo.getOfferDetails(this.id)
        if (response.status === 200) {
          this.show = false
          this.description = response.data.html
          this.appIcon = this.base + response.data.icon
          this.background = this.base + '/' + response.data.image
          this.mtnAppName = response.data.title
          this.appstore = response.data.appleLink
          this.googleplay = response.data.link
          this.price = response.data.price === 0 ? this.$t('free') : response.data.price + this.$t('Bundles.sp')
          this.isActive = response.data.isActive === 1
          // console.log(this.background)
          this.active = this.isActive
          this.fetched = true
          if (this.offerType === 'special') {
            this.unit = `${response.data.validity === 1 ? '' : response.data.validity} ${response.data.type === 0 ? this.$t('Bundles.day') : response.data.type === 1 ? this.$t('Bundles.week') : this.$t('Bundles.month')}`
            this.miniCards = [{
              title: response.data.dataSize + ' ' + response.data.dataUnit,
              description: response.data.dataNote,
              icon: 'internet.svg'
            }, {
              title: response.data.minuteCount + this.$t('Bundles.min'),
              description: response.data.minuteNote,
              icon: 'calls.svg'
            }, {
              title: response.data.smsCount + this.$t('Bundles.sms'),
              description: response.data.smsNote,
              icon: 'SMS.svg'
            },
            {
              title: this.$t('Bundles.activation'),
              description: this.$t('Bundles.dial') + response.data.activationCode + this.$t('Bundles.activate'),
              icon: 'code.svg'
            },
            {
              title: this.$t('Bundles.validation'),
              description: `${this.$t('Bundles.validFor')}${response.data.validity} ${response.data.type === 0 ? this.$t('Bundles.day') : response.data.type === 1 ? this.$t('Bundles.week') : this.$t('Bundles.month')}${this.$t('Bundles.renewed')}`,
              icon: 'validation.svg'
            }
            ]
          }
        } else {
          this.error = true
          this.show = false
        }
      } catch (e) {
        this.error = true
        this.show = false
        console.log(e)
      }
    }
    // filter (val) {
    //   this.filterType = val
    //   this.arabicRadio()
    // }
  }
}
</script>

<style scoped lang="scss">
  @import "src/assets/sass/main";
  .bundle {
    margin: 1vw 2vw;
    min-width: 169px; min-height: 169px;
    max-width: 247px; max-height: 247px;
    width: 15.2vw; height: 15.2vw;
  }
  .bundle-basic {
    padding: 0 0.5rem;
    border: 3px solid rgba(255, 255, 255, 0.1); border-radius: 25px;
    width: 100%; height: 100%;
  }
  .card-icon {
    margin-bottom: 0.7rem;
  }
  .card-icon img {
    width: 55px; height: 33px;
  }
  .card-title {
    font-size: 19px;
    //font-family: Mtn-bold;
    font-style: italic;
    color: $--yellow;
    margin-bottom: 0.7rem;
  }
  .card-description {
    font-size: 13px;
    height: 42px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .padding-en {
    padding: 0px 4vw 0vw 0vw;
  }
  .padding-ar {
    padding: 0px 0vw 0vw 4vw;
  }
  #offerDetails {
    padding-top: 157px;
  }
  #offerDetails .social-nav{
  //background: rgba(212, 212, 212, 0.45);
  //background-color: $--light-white;
    height: 48px;
  //box-shadow: 10px 10px 30px 0px rgba(0, 0, 0, 0.1) !important;
    background: rgba(242, 242, 242, 1);
    box-shadow: 0 15px 25px rgba(0, 0, 0, 0.1);
  //backdrop-filter: blur(40px);
    margin: 0px 0px;
    display: flex;
    position: fixed;
    z-index: 10;
    z-index: 210;
    top: 110px;
  }
  .arabicBack{
    right: 4vw;
    left: unset !important;
    transform: rotateY(180deg);
  }
  .arabicSearch{
    right: 0 !important;
    left: unset !important;
  }
  #offerDetails .nameContainer{
    display: flex;
    padding: 0 4vw 0 3.2vw;
  }
  #offerDetails .homeIcon {
    cursor: pointer;
  }
  .homeIcon,
  .arrowIcon,
  .titleName{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1vw;
  }
  #offerDetails .titleName{
    width: max-content;
    color: $--yellow;
    font-family: Mtn-bold;
    text-decoration: underline;
  }
  #offerDetails .bundleTitle{
    direction: ltr;
    width: max-content;
    font-family: Mtn-regular;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1vw;
  }
  .backArrow{
    width: 35px;
    height: 35px;
    margin-bottom: 50px;
  }
  .filterForm{
    display: flex;
  }
  .checkContainer{
    display: flex;
    justify-content: flex-end;
    width: 50vw;
    padding: 0 3vw;
    font-family: Mtn-regular;
  }
  .check{
    padding: 0 2vw;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .checkName{
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Mtn-bold;
    font-style: italic;
  }
  [type="radio"]:checked,
  [type="radio"]:not(:checked) {
    position: absolute;
    left: -9999px;
  }
  [type="radio"]:checked + label,
  [type="radio"]:not(:checked) + label
  {
    position: relative;
    padding-left: 28px;
    cursor: pointer;
    line-height: 20px;
    display: inline-block;
    color: #1D1D1D;
  }
  [type="radio"]:checked + label:before,
  [type="radio"]:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 18px;
    height: 18px;
    border: 2.5px solid $--yellow;
    border-radius: 100%;
    background: transparent;
  }
  [type="radio"]:checked + label:after,
  [type="radio"]:not(:checked) + label:after {
    content: '';
    width: 8px;
    height: 8px;
    background: $--yellow;
    position: absolute;
    top: 5px;
    left: 5px;
    border-radius: 100%;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }
  [type="radio"]:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  [type="radio"]:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
    font-weight: bold;
  }
  input[type="radio"]:checked+label {
    font-family: Mtn-bold;
    /*font-family: Mtn-arabic-bold;*/
  }
  @media screen and (max-width: 650px) {
    .checkName {
      display: none;
    }
  }
  @media screen and (max-width: 950px) {
    /*.homeIcon,*/
    /*.arrowIcon,*/
    /*#Digital-services .bundleTitle,*/
    /*.checkName{*/
    /*  display: none;*/
    /*}*/
    /*.nameContainer{*/
    /*  width: 40vw !important;*/
    /*}*/
    .checkContainer{
      width: 60vw !important;
    }
  }
  .mtnRadioContainer{
    min-height: calc(100vh - (170px + 277.2px));
    background-image: linear-gradient(to bottom, #F2F2F2, #e1e1e1);
  }
  .Radiobackground{
    min-height: calc(100vh - (170px + 277.2px));
    padding-top: 30px; padding-bottom: 4vw;
    background-image: url('../../assets/icons/digitalServices.svg');
    background-position-x: right;
  }
  .mainContainer{
    display: flex;
    position: relative;
  }
  .radioImage{
    //height: 280px;
    //width: 500px;
    width: 100%;
    height: auto;
    //max-width: 532px;
    border-radius: 28px;
  }
  .mtnRadioText {
    //width: 70%;
    width: 58.33333333%;
    padding: 60px 4vw;
    text-align: left;
  }
  .mtnRadioImage {
    /*width: 40%;*/
    width: 41.66666667%;
    display: flex;
    align-items: center;
  }
  .arabicDir{
    text-align: right !important;
  }
  .rightButtons{
    display: flex;
    justify-content: right!important;
  }
  .main-title {
    font-style: italic;
  }
  .v-btn {
    text-transform: initial!important;
  }
  .download {
    font-size: 10px!important;
  }
  .icon {
    margin-right: 7px;
    width: 22px;
  }
  .buttons{
    display: flex;
  }
  .mtnBack{
    position: absolute;
    top: 30px;
    padding: 0 4vw;
  }
  .MTMRadioTitle{
    font-size: 30px;
    color: $--yellow;
    font-family: Mtn-bold;
    padding: 15px 0;
  }
  .radioIcon{
    /*height: 90px;*/
    /*width: 80px;*/
    width: 44px;
    height: 52px;
  }
  .radioDescription{
    /*padding: 0 2vw*/
  }
  .mtnRadioImageSmall{
    display: none;
  }
  @media screen and (max-width: 992px) {
    #offerDetails .mtnRadioImageSmall {
      display: block;
      padding-bottom: 2vh;
      max-width: 484px !important;
    }
    .mtnRadioImage{
      display: none;
    }
    .mtnRadioText {
      width: 100%;
    }
    }
  .yellowButton{
    padding: 50px 2vw;
  }
  @media screen and (max-width: 381px) {
    .buttons {
      display: block;
    }
  }
  #offerDetails .theme--light.v-btn.v-btn--has-bg {
    background: transparent !important;
  }
  .mainTitle {
    display: flex;
    justify-content: center;
    align-items: center;
    /*padding: 0 20px;*/
  }
  .priceContainer{
    padding-bottom: 25px;
    font-style: italic;
  }
  .Price{
    font-family: Mtn-bold;
    font-size: 20px;
    font-style: normal;
  }
  .month{
    font-family: Mtn-bold;
    font-size: 12px;
  }
  .leftPosition {
    background-position-x: left;
  }
  .rightPosition {
    background-position-x: right;
  }
  .rightPadding{
    padding: 60px 5vw !important
  }
  label {
    margin: 0 1rem;
  }
  /*--- switch button ----*/
  /* The switch - the box around the slider */
  .switch {
    font-size: 17px;
    position: relative;
    display: inline-block;
    width: 2.8em;
    height: 1.5em;
    border-radius: 50px;
    box-shadow: 10px 10px 20px rgba(0,0,0,0.08)
  }
  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    inset: 0;
    border: 2px solid $--yellow;
    border-radius: 50px;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }
  .inactive {
    border: 2px solid #6A6A6A;
  }
  .inactive.slider:before {
    background-color: #6A6A6A;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 1em;
    width: 1em;
    left: 0.2em;
    bottom: 0.14em;
    background-color: $--yellow;
    border-radius: inherit;
    transition: all 0.4s cubic-bezier(0.23, 1, 0.320, 1);
  }
  .slider-border {
    height: 1em;
    width: 1em;
    border: .8px solid #ffffff;
    border-radius: 50%;
    position: absolute;
    left: 0.32em;
    bottom: 0.25em;
    filter: blur(1px);
    transition: all 0.4s cubic-bezier(0.23, 1, 0.320, 1);
    cursor: pointer;
  }

  .switch input:checked + .slider:before {
    transform: translateX(1.2em);
  }
  /*---------------------------------*/
</style>
